import React from 'react';
import { Collapse } from 'antd';
import KpiSelector from './KpiSelector';
import SensitivityRow from './SensitivityRow';
import { StyledCollapse } from './styled';
import PanelHeader from './PanelHeader';

// Groups the built-in and custom KPI dropdown together with the Beta KPI-based metrics
// in a collapse panel so the header line matches Metrics (title + Info / Warning / Critical).
const KpiMetricsSection = ({
  betaMetricEntries,
  sensitivityList = [],
  allMetricNames = [],
  showAICohortButton = false,
  disableAICohortButton = false,
}) => {
  return (
    <StyledCollapse defaultActiveKey={['kpi-metrics']} collapsible="disabled">
      <Collapse.Panel
        key="kpi-metrics"
        showArrow={false}
        header={
          <PanelHeader
            metric="KPI-based Metrics"
            metrics={allMetricNames}
            showAICohortButton={showAICohortButton}
            disableAICohortButton={disableAICohortButton}
            isFlow={false}
            showBeta
          />
        }
      >
        <KpiSelector />
        {betaMetricEntries.map(({ name }) => (
          <SensitivityRow
            key={name}
            sensitivity={sensitivityList.find((s) => s.metricKey === name)}
            isBeta
            metricKey={name}
          />
        ))}
      </Collapse.Panel>
    </StyledCollapse>
  );
};

export default React.memo(KpiMetricsSection);
